import {
    type RemoveSubEventPhotoResponseType,
    type RemoveSubEventPhotoRequestType
} from "./type";
import {
    request
} from "../request";

const removeSubEventPhoto = async (params: RemoveSubEventPhotoRequestType): Promise<RemoveSubEventPhotoResponseType> => {
    return await request<RemoveSubEventPhotoResponseType>("/events/removeSubEventPhoto", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default removeSubEventPhoto;
